import React from 'react';
import { Box } from '@mui/material';
import { EllipsisText } from '@ui/EllipsisText';

const ICON_BOX_SIZE_PX = 30;

/**
 * Headline for the CSV-import side panels. Mirrors the Element side panel
 * layout: a 30×30 square icon flush-left (matching the IconButton footprint
 * used by `ElementCategoryMenuIconButton`), followed by `HeaderTextBox`
 * typography (15px / 400). The icon aligns vertically with the title row
 * only; subtitle shares the title text column so both lines stay flush.
 */
export const SidePanelHeader: React.FC<{
  icon: React.ReactNode;
  title: string;
  subtitle?: string;
}> = ({ icon, title, subtitle }) => (
  <Box
    sx={{
      display: 'flex',
      gap: 1,
      alignItems: 'flex-start',
    }}
  >
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexShrink: 0,
        height: ICON_BOX_SIZE_PX,
        justifyContent: 'center',
        width: ICON_BOX_SIZE_PX,
      }}
    >
      {icon}
    </Box>
    <Box
      sx={{
        flex: 1,
        minWidth: 0,
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          minHeight: ICON_BOX_SIZE_PX,
        }}
      >
        <EllipsisText
          verticalAlign="middle"
          sx={{ fontSize: '15px', fontWeight: 400, lineHeight: 1.2 }}
        >
          {title}
        </EllipsisText>
      </Box>
      {subtitle && (
        <EllipsisText
          verticalAlign="middle"
          sx={{
            color: 'text.secondary',
            fontSize: 12,
            lineHeight: 1.2,
          }}
        >
          {subtitle}
        </EllipsisText>
      )}
    </Box>
  </Box>
);
